// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
    background: rgb(230,230,230); 
    width: 100%;
    height: 100%;
}
main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 80px;
}`, "",{"version":3,"sources":["webpack://./src/commonStyles/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;AACA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":["*{\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\nbody {\n    background: rgb(230,230,230); \n    width: 100%;\n    height: 100%;\n}\nmain {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 80px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
